import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Form, Select } from 'antd';

const RegistrationCodeInput = ({
  name,
  disabled = false,
  partnershipId,
  load,
  options,
  placeholder,
  label = null,
  rules = [],
  defaultLimit,
  defaultOrder,
  filter,
  ...props
}) => {
  // load tags on mount
  useEffect(() => {
    load(1, defaultLimit, defaultOrder, filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Translation>
      {(t) => (
        <div className='form-group'>
          <Form.Item
            name={name || 'registration_code_id'}
            rules={rules}
            label={t(label)}
          >
            <Select
              showSearch
              disabled={props.isLoading || props.isSubmitting}
              loading={props.isLoading}
              placeholder={placeholder || t('registration_code_code')}
            >
              {options.map((x) => (
                <Select.Option key={x.id} value={x.id}>
                  {x.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      )}
    </Translation>
  );
};

export default RegistrationCodeInput;
